import { GuidedTour } from '@talend/react-containers';

export const REDUCER_KEY = 'GuidedTour';

export function guideTourReducer(state = { isOpen: false }, action: any) {
	switch (action.type) {
		case GuidedTour.constants.GUIDED_TOUR_SHOW:
			return { ...state, isOpen: true };
		case GuidedTour.constants.GUIDED_TOUR_HIDE:
			return { ...state, isOpen: false };
		default:
			return state;
	}
}
